import React from 'react';
import { Target, Activity } from 'lucide-react';
import classNames from 'classnames';

const RoleSelection = ({ onSelect }) => {
    return (
        <div className="flex flex-col items-center justify-center h-full p-6 text-center">
            <h2 className="text-3xl font-bold mb-2 text-white">Select Your Role</h2>
            <p className="text-gray-400 mb-8">Choose your specialized analysis mode</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-2xl">
                <button
                    onClick={() => onSelect('bowler')}
                    className="group relative bg-gray-800 hover:bg-gray-700 border border-gray-700 hover:border-neon-cyan/50 p-8 rounded-2xl transition-all duration-300 flex flex-col items-center text-left"
                >
                    <div className="w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                        <Activity className="text-blue-500 w-8 h-8" />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">Bowler</h3>
                    <p className="text-sm text-gray-400">Analyze delivery stride, impulse, release angle, and follow-through mechanics.</p>
                </button>

                <button
                    onClick={() => onSelect('batsman')}
                    className="group relative bg-gray-800 hover:bg-gray-700 border border-gray-700 hover:border-green-500/50 p-8 rounded-2xl transition-all duration-300 flex flex-col items-center text-left"
                >
                    <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                        <Target className="text-green-500 w-8 h-8" />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">Batsman</h3>
                    <p className="text-sm text-gray-400">Analyze stance, backlift, impact timing, and shot mechanics.</p>
                </button>
            </div>
        </div>
    );
};

export default RoleSelection;
